// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y7wPEMclPMHTv1fzYRQR {
    margin: auto auto;
    width: 100%;
    height: 90vh;
    display: flex ;
    flex-direction: column; 
    align-items: center;
    justify-content: center;
}

.ypn9rLxfLPAumfHIwUgg {
    position: relative;
    width: 100%;
    aspect-ratio:3 / 3.5;
}
@media(min-width: 500px) {
    .ypn9rLxfLPAumfHIwUgg {
        width: auto;
        height: 100%;
        aspect-ratio: 4.5 / 3;
    }
}`, "",{"version":3,"sources":["webpack://./src/Map.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;IACzB;AACJ","sourcesContent":[".MapWrapper {\n    margin: auto auto;\n    width: 100%;\n    height: 90vh;\n    display: flex ;\n    flex-direction: column; \n    align-items: center;\n    justify-content: center;\n}\n\n.Aspect {\n    position: relative;\n    width: 100%;\n    aspect-ratio:3 / 3.5;\n}\n@media(min-width: 500px) {\n    .Aspect {\n        width: auto;\n        height: 100%;\n        aspect-ratio: 4.5 / 3;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MapWrapper": `y7wPEMclPMHTv1fzYRQR`,
	"Aspect": `ypn9rLxfLPAumfHIwUgg`
};
export default ___CSS_LOADER_EXPORT___;
